import * as React from 'react';
import { ApiError } from 'core/types';

// Local Imports
import {
  useUserStateErrorSelector,
  useUserStateErrorsSelector,
  LOGIN_ERROR,
} from 'state/user/userSlice';
import {
  useRegistrationStateErrorSelector,
  useRegistrationStateErrorsSelector,
} from 'state/registration/registrationSlice';
import {
  useHouseholdErrorSelector,
  useHouseholdErrorsSelector,
} from 'state/households/householdSlice';
import {
  useFormStateErrorSelector,
  useFormStateErrorsSelector,
} from 'state/form/formSlice';
import { useToast } from '@teamsnap/snap-ui';

export const ErrorHandler = () => {
  const { toast } = useToast();

  const userError = useUserStateErrorSelector();
  const userErrors = useUserStateErrorsSelector();

  const registrationError = useRegistrationStateErrorSelector();
  const registrationErrors = useRegistrationStateErrorsSelector();

  const householdError = useHouseholdErrorSelector();
  const householdErrors = useHouseholdErrorsSelector();

  const formError = useFormStateErrorSelector();
  const formErrors = useFormStateErrorsSelector();

  const setErrorMessage = (error: string[] | ApiError[]) => {
    if (Array.isArray(error)) {
      if ((error[0] as ApiError)?.message) {
        return error.map((error) => (error as ApiError)?.message).join(' ');
      } else {
        return error.join(' ');
      }
    } else {
      return error;
    }
  };

  const handleState = () => {
    if (userError && userErrors?.length > 0 && userErrors[0] !== LOGIN_ERROR) {
      const message = setErrorMessage(userErrors);
      toast({ title: message, variant: 'negative' });
    }
    if (registrationError) {
      const message = setErrorMessage(registrationErrors);
      toast({ title: message, variant: 'negative' });
    }
    if (householdError) {
      const message = setErrorMessage(householdErrors);
      toast({ title: message, variant: 'negative' });
    }
    if (formError) {
      const message = setErrorMessage(formErrors);
      toast({ title: message, variant: 'negative' });
    }
  };

  React.useEffect(() => {
    handleState();

    return () => {
      // Cleanup logic if needed
    };
  }, [userError, registrationError, householdError, formError]);

  return null; // No UI is rendered
};
